<template>
  <div class="container-fluid" id="reject-step">
    <h3 class="fs-4">{{ t("SORRYNOTINTERESTED") }}</h3>
    <h5 class="mt-3 fs-6">{{ t("WHYNOTINTERESTED") }}</h5>
    <div id="options-section" class="mt-10 text-center">
      <button
        class="mt-3"
        :class="selectedReason === 1 ? 'active-option' : 'option-btn'"
        @click="setSelectedOption(1)"
      >
        {{ t("rejectReasons.first") }}
      </button>
      <button
        class="mt-3"
        :class="selectedReason === 2 ? 'active-option' : 'option-btn'"
        @click="setSelectedOption(2)"
      >
        {{ t("rejectReasons.second") }}
      </button>
      <button
        class="mt-3"
        :class="selectedReason === 3 ? 'active-option' : 'option-btn'"
        @click="setSelectedOption(3)"
      >
        {{ t("rejectReasons.third") }}
      </button>
      <button
        class="mt-3"
        :class="selectedReason === 4 ? 'active-option' : 'option-btn'"
        @click="setSelectedOption(4)"
      >
        {{ t("rejectReasons.fourth") }}
      </button>
      <button
        class="mt-3"
        :class="selectedReason === 5 ? 'active-option' : 'option-btn'"
        @click="setSelectedOption(5)"
      >
        {{ t("rejectReasons.fifth") }}
      </button>
      <button class="mt-3 go-back-btn" @click="$emit('goBack')">
        {{ t("GO_BACK_TO_CL_OFFER") }}
      </button>
      <button class="mt-3 reject-offer-btn" @click="sendRejectionSurvey">
        {{ t("CONTINUECANCEL") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";

declare const Android: AndroidInterface;

export default defineComponent({
  name: "RegistrationRejectOffer",
  emits: ["showNotSelectedRejectReasonAlert", "goBack"],
  setup(_, { emit }) {
    const { t } = useI18n();
    const selectedReason = ref<number>(0);

    const cancelReasonTitle = computed(() => {
      switch (selectedReason.value) {
        case 1:
          return t("rejectReasons.first");
        case 2:
          return t("rejectReasons.second");
        case 3:
          return t("rejectReasons.third");
        case 4:
          return t("rejectReasons.fourth");
        case 5:
          return t("rejectReasons.fifth");
        default:
          return "";
      }
    });

    const setSelectedOption = (selected: number) =>
      (selectedReason.value = selected);

    const gtagEventDeclineOffer = (reason: string) =>
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.ClickDeclineReason,
        "Offer",
        reason
      );

    const sendRejectionSurvey = () => {
      if (selectedReason.value !== 0) {
        gtagEventDeclineOffer(cancelReasonTitle.value);
        if (isAndroid()) {
          Android.creditOfferRejected();
        }
      } else {
        emit("showNotSelectedRejectReasonAlert");
      }
    };

    return { t, selectedReason, setSelectedOption, sendRejectionSurvey };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.option-btn {
  width: 100%;
  height: 50px;
  background-color: $pj-color-white;
  border-radius: 5px;
  color: $pj-color-green;
  text-align: left;
  font-size: 5vw;
  padding-left: 2.5%;
  border-color: $pj-color-green;
  border-width: thin;
}

.active-option {
  width: 100%;
  height: 50px;
  border: none;
  background-color: $pj-color-yellow-green;
  border-radius: 5px;
  color: $pj-color-white;
  text-align: left;
  font-size: 5vw;
  padding-left: 2.5%;
}

.go-back-btn {
  background: $pj-color-green;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 100%;
  height: 40px;
  border: none;
}

.reject-offer-btn {
  background: transparent;
  border-radius: 11px;
  font-style: normal;
  text-decoration: underline;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-green;
  width: 90%;
  height: 40px;
  border: none;
}

.reject-offer-btn-disabled {
  background-color: $pj-color-gray;
  cursor: not-allowed;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 90%;
  height: 40px;
  border: none;
}
</style>
